export default "__VITE_ASSET__lNwB1jIz__"